import React from 'react';
import { Header } from './components/Header';
import { ArticleContent } from './components/ArticleContent';
import { CTASection } from './components/CTASection';
import { RelatedArticles } from './components/RelatedArticles';
import { SocialShare } from './components/SocialShare';
export function App() {
  return <div className="bg-white min-h-screen" data-id="element-0">
      <div className="max-w-3xl mx-auto px-5 py-8" data-id="element-1">
        <Header data-id="element-2" />
        <ArticleContent data-id="element-3" />
        <CTASection data-id="element-4" />
        <SocialShare data-id="element-5" />
        <RelatedArticles data-id="element-6" />
      </div>
    </div>;
}